import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-2">
              最新爆料
            </h2>
            <p className="text-sm text-secondary-500">
              每日更新热门网络爆料事件，不错过任何一个瓜
            </p>
          </div>
          <Link
            to="/category/yulequan"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}